var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1824 0.817247C30.0936 -0.272407 28.3252 -0.272407 27.2364 0.818545L15.9997 12.0608L4.76404 0.818545C3.67308 -0.272848 1.90641 -0.272416 0.818059 0.817247C-0.272038 1.90734 -0.272902 3.67355 0.816762 4.76323L12.0546 16.0077L0.816762 27.2511C-0.272893 28.3408 -0.272029 30.1074 0.818059 31.1971C1.36268 31.7421 2.07639 32.0138 2.79055 32.0138C3.50516 32.0138 4.21976 31.7417 4.76437 31.1958L16 19.9535L27.2356 31.1958C27.7807 31.7417 28.4944 32.0138 29.2095 32.0138C29.9232 32.0138 30.6378 31.7417 31.1819 31.1971C32.272 30.1074 32.2729 28.3408 31.1832 27.2511L19.9432 16.0066L31.1821 4.76212C32.2718 3.6729 32.2714 1.90626 31.1813 0.815696L31.1824 0.817247Z",
    fill: "#444444"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.9a0b181c7e3fd08815dcbbd1df4f7d6e.svg";
export { ForwardRef as ReactComponent };